import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  RefObject,
  SetStateAction,
  useMemo,
  useState,
} from 'react';

import { TablePropsType } from '../types/campaignBuilder.js';

export type TableContentType = TablePropsType & {
  wrapperRef: RefObject<HTMLDivElement | null>;
};

type TableContextType = {
  tableContent: TableContentType | null;
  setTableContent: Dispatch<SetStateAction<TableContentType | null>>;
};

export const TableContentContext = createContext<TableContextType | null>(null);

const TableContentContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [tableContent, setTableContent] = useState<TableContentType | null>(
    null,
  );

  const value = useMemo(
    () => ({ tableContent, setTableContent }),
    [tableContent, setTableContent],
  );

  return (
    <TableContentContext.Provider value={value}>
      {children}
    </TableContentContext.Provider>
  );
};

export default TableContentContextProvider;
